import { Dexterity, baseballLogicService, INewDataGridRow } from '@trackman/baseball-shared-components';
import _ from 'lodash';
import { EditRowDataKey } from 'enums/EditRowDataKey';
import { emptyPlayer } from 'constants/Constants';
import { PlayRowProps } from './PlayRowProps';
import { IEditRowInning } from '../../interfaces/sessionVerification/plays/IEditRowInning';
import { PlayerTrackingColumnName } from 'constants/PlayerTrackingColumnName';
import { DataKey } from 'enums/DataKey';
import { BallTrackingColumnName } from 'constants/BallTrackingColumnName';

export class PlayRow extends PlayRowProps implements INewDataGridRow {
  [index: string]: any;

  isFirstPlayInInning = false;

  getValue(dataKey: string) {
    return this[dataKey];
  }

  isVisible() {
    return !this.isDeleted && this.displayIndex > -1;
  }

  get isHomeTeamBatting() {
    return baseballLogicService.isHomeTeamBatting(this.inning.isTopInning);
  }

  clone(): PlayRow {
    return _.cloneDeep(this);
  }

  update(dataKey: string, newValue: any): void {
    const oldValue = this[dataKey];
    if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
      return;
    }
    this[dataKey] = newValue;
    this.isChanged = true;

    if (Object.values(PlayerTrackingColumnName).includes(dataKey)) {
      this.isPlayerTrackingChanged = true;
    }

    if (Object.values(BallTrackingColumnName).includes(dataKey)) {
      this.isBallTrackingChanged = true;
    }

    if (dataKey === EditRowDataKey.Inning && (oldValue as IEditRowInning).isTopInning !== (newValue as IEditRowInning).isTopInning) {
      this.pitcher = {
        ...emptyPlayer,
        name: '',
        teamName: baseballLogicService.isHomeTeamBatting((newValue as IEditRowInning).isTopInning)
          ? this.awayTeam.name
          : this.homeTeam.name,
      };
      this.batter = {
        ...emptyPlayer,
        name: '',
        teamName: baseballLogicService.isHomeTeamBatting((newValue as IEditRowInning).isTopInning)
          ? this.homeTeam.name
          : this.awayTeam.name,
      };
      this.catcher = {
        ...emptyPlayer,
        pitchingHandedness: Dexterity.Undefined,
        name: '',
        teamName: baseballLogicService.isHomeTeamBatting((newValue as IEditRowInning).isTopInning)
          ? this.awayTeam.name
          : this.homeTeam.name,
      };
    }
  }

  changeTeam(newTeamName: string, isHomeTeam: boolean) {
    if (this.isHomeTeamBatting === isHomeTeam) {
      if (this.batter.isPlaceholder) {
        this.batter.teamName = newTeamName;
      } else {
        this.batter = { ...emptyPlayer, name: '', teamName: newTeamName };
      }
    } else {
      if (this.pitcher.isPlaceholder) {
        this.pitcher.teamName = newTeamName;
      } else {
        this.pitcher = { ...emptyPlayer, name: '', teamName: newTeamName };
      }
      if (this.catcher.isPlaceholder) {
        this.catcher.teamName = newTeamName;
      } else {
        this.catcher = { ...emptyPlayer, name: '', teamName: newTeamName, pitchingHandedness: Dexterity.Undefined };
      }
    }
    this.isChanged = true;
    this.isBallTrackingChanged = true;
    this.isPlayerTrackingChanged = true;
  }
}
